module.exports = __webpack_public_path__ + "Subregion-map.326288e26d7be58c9b92ba91e27df2c5.png";